import styled from "@emotion/styled";

const StatusSelect = styled.select`
  border: none;
  font-weight: bold;
  outline: none;
`;

export default StatusSelect;
